module.exports = "../images/expect-hunting@2x.jpg?v=bdbde59";